export default "__VITE_PUBLIC_ASSET__1f0d8eb9__"